<template>
    <div>
        <el-dialog :visible.sync="showDigitalVoucherWildCard" :center="true" :width="widthModal()"
            :height="heightModal()" :style="{ marginTop: marginTopModal() }" @close="closeModalWildcard">
            <div class=" justify-content-center flex-column text-center text-bat popups-wildcard-rent"
                style="word-break: normal">
                <div>
                    <div>
                        <div class="d-flex justify-content-between header">
                            <div class="header">
                                <h5 class="text-start text-title-bat">Comodín digital</h5>
                            </div>
                        </div>
                    </div>
                    <div class="mb-2">
                        <div class="d-flex flex-column text-start">
                            <div>
                                <p class="text-title-wildcard"> Alcanza el 100% de tu meta y suma un 1% a tu renta.
                                </p>
                            </div>

                            <div class="d-flex">
                                <img src="/img-version2/icons/estrella-verde.svg" alt=""
                                    class="tag-initial-border">
                                <div>
                                    <p class="text-comodin"><strong>Comodín digital:</strong> El cumplimiento de este comodín puede llegar
                                        hasta el 100%.
                                    </p>
                                </div>
                            </div>
                            <hr class="mt-0 mb-1">
                        </div>
                    </div>

                    <div>
                        <div class="row">
                            <div class="col text-bat">
                                <p class="mb-0 text-start text-title-bat text-title-wildcard">Estados de cumplimiento del comodín
                                </p>
                                <div class="d-flex mt-2">
                                    <div class="vertical-line">
                                        <span class="traffic-light tag-initial p-0"></span>
                                        <span>0% hasta < 100%</span>
                                    </div>
                                    <div>
                                        <span class="traffic-light tag-high p-0"></span>
                                        <span>100%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    components: {

    },
    props: {
        url_media: {
            default: '',
        },
        closeModalWildcard: Function
    },
    data() {
        return {
            showDigitalVoucherWildCard: true,
        }
    },
    mounted() {

    },
    created() {

    },
    methods: {


        widthModal() {
            let width = '100% !important';
            if (this.$mq === 'md') {
                width = '80% !important';
            } else if (this.$mq === 'lg') {
                width = '90% !important';
            } else if (this.$mq === 'xl') {
                width = '95%';
            }
            return width;
        },
        heightModal() {
            let height = 'auto';
            if (this.$mq === 'md') {
                height = '80vh';
            } else if (this.$mq === 'lg') {
                height = '90vh';
            } else if (this.$mq === 'xl') {
                height = '95vh';
            }
            return height;
        },
        marginTopModal() {
            return '0vh ';
        }
    },
}
</script>
